import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from "../../store/actions/index";
import { Button } from "@material-ui/core";
import CachedIcon from '@material-ui/icons/Cached';
import t from "../../languages/pl";

import { TooltipTop as CustomTooltip } from "../Common/CustomTooltips";
const ResetFilters = props => {
    const { onReset } = props;

    const handleResetClick = () => {
        if(!onReset) {
            props.resetToDefaults();
        }
        else onReset();
    };

    return (
        <CustomTooltip title={t.resetFilters}>
            <Button
                style={{minWidth: 30}}
                onClick={handleResetClick}
            >
                <CachedIcon />
            </Button>
        </CustomTooltip>
    );
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


ResetFilters.propTypes = {
    onReset: PropTypes.func,
    //redux
    resetToDefaults: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(ResetFilters);
